import { getUserRoute, logoutRoute } from "./api-routes";
import performRequest from "./perform-request";
import { clearSanctumToken } from "../lib/auth-token";

export const getUser = () => {
  return performRequest("GET", getUserRoute, null, true);
};

export const logoutUser = (changeUser) => {
  return performRequest("POST", logoutRoute, null, true)
    .catch((error) => {
      console.log("Logout failed", error);
    })
    .finally(() => {
      localStorage.removeItem("selectedOrganization");
      localStorage.removeItem("selectedGestionCustomer");
      localStorage.removeItem("isLoggedIn");
      clearSanctumToken();
      changeUser(null);
    });
};
